import { SVGProps } from 'react';

const Undo2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 4 4 9l5 5M4 9h10.5a5.5 5.5 0 1 1 0 11H11"
    />
  </svg>
);
export default Undo2;
